/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_OrderInputs */

const en_tables_custom_properties_order = /** @type {(inputs: Tables_Custom_Properties_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Order`)
};

const de_tables_custom_properties_order = /** @type {(inputs: Tables_Custom_Properties_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Properties Order" |
*
* @param {Tables_Custom_Properties_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_order = /** @type {((inputs?: Tables_Custom_Properties_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_order(inputs)
	return de_tables_custom_properties_order(inputs)
});